import { getIndorImageSrc, IndorImages } from "../../../../features"
import { getItemWebStorage } from "../../../../features/webStorageSaver"
import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import { setSearchLineIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { store } from "../../../../stateManagement/store"
import { ContentHeaderButton } from "../../contentHeaderButton"
import GroupByRaionsSwitcher from "./specialWidgets/GroupByRaionsSwitcher"

const searchLineButtonIconSrc = getIndorImageSrc(IndorImages.MapNavigateZoom);

export default function ContentHeaderRoadsListWidgets() {

    const currentConfig = getItemWebStorage('currentConfig');
    const pathsListCanBeGroupedByRaions = currentConfig?.pathsListCanBeGroupedByRaions


    const searchLineIsShown = useAppSelector(state => state.contentHeader.searchLineIsShown)

    function controlSearchLineButton() {
        const searchLineIsShown = store.getState().contentHeader.searchLineIsShown
        store.dispatch(setSearchLineIsShown(!searchLineIsShown))
    }

    const widgetsConfigArray = [
        {
            active: searchLineIsShown,
            name: "Поиск",
            imageSrc: searchLineButtonIconSrc,
            onClick: controlSearchLineButton
        }
    ]

    return (
        <>
            {pathsListCanBeGroupedByRaions &&
                <GroupByRaionsSwitcher />
            }
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            key={name}
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                        />
                    )
                }
            })}
        </>
    )
}